export const AUTH = 'AUTH'
export const LOGIN = 'LOGIN'
export const ACTIVATE = 'ACTIVATE'
export const USER = 'USER'
export const PROJECTGET = 'PROJECTGET'
export const USERLIST = 'USERLIST'
export const EVENT = 'EVENT'
export const USERBYUID = 'USERBYUID'
export const EVENTBYUID = 'EVENTBYUID'
export const PROJECTBYUID = 'PROJECTBYUID'
export const TOPPROJECT = 'TOPPROJECT'
export const ALLPROJECT = 'ALLPROJECT'
export const ALLEVENT = 'ALLEVENT'
export const EVENTBYID = 'EVENTBYID'
export const PROJECTBYID = 'PROJECTBYID'
export const GETFAQ = 'GETFAQ'